import styled from 'styled-components';
import { Checkbox } from 'antd';
import { CONSTANTS } from './constants';

export const ToggleGroup = styled.div`
  display: inline-block;
  border: 1px solid #c7c7c7;
  background: white;
  border-radius: 4px;
  padding: 9px 0px 0 10px;
  margin-bottom: 15px;
  margin-right: 15px;
  margin-top: 15px;
  b {
    display: block;
  }
`;

export const ToggleButton = styled(Checkbox)`
  margin: 10px 18px 12px 2px;
  font-weight: normal;
  &.active-garages .ant-checkbox-checked span {
    background: ${CONSTANTS.garage.active.colour};
    border-color: ${CONSTANTS.garage.active.colour};
  }
  &.suspended-garages .ant-checkbox-checked span {
    background: ${CONSTANTS.garage.suspended.colour};
    border-color: ${CONSTANTS.garage.suspended.colour};
    &::after {
      border-color: black;
    }
  }
  &.deleted-garages .ant-checkbox-checked span {
    background: ${CONSTANTS.garage.deleted.colour};
    border-color: ${CONSTANTS.garage.deleted.colour};
  }
  &.active-drivers .ant-checkbox-checked span {
    background: ${CONSTANTS.driver.active.colour};
    border-color: ${CONSTANTS.driver.active.colour};
  }
  &.suspended-drivers .ant-checkbox-checked span {
    background: ${CONSTANTS.driver.suspended.colour};
    border-color: ${CONSTANTS.driver.suspended.colour};
  }
  &.fixter-cnd .ant-checkbox-checked span {
    background: ${CONSTANTS.garage.active.Fixter.colour};
    border-color: ${CONSTANTS.garage.active.Fixter.colour};
  }
  &.garage-cnd .ant-checkbox-checked span {
    background: ${CONSTANTS.garage.active['GarageC&D'].colour};
    border-color: ${CONSTANTS.garage.active['GarageC&D'].colour};
  }
  &.customer-cnd .ant-checkbox-checked span {
    background: ${CONSTANTS.garage.active['CustomerC&D'].colour};
    border-color: ${CONSTANTS.garage.active['CustomerC&D'].colour};
  }
  &.marketing-districts .ant-checkbox-checked span {
    background: ${CONSTANTS['marketing-districts'].colour};
    border-color: ${CONSTANTS['marketing-districts'].colour};
  }
`;

export const PostcodeSearchContainer = styled.div`
  position: absolute;
  right: 62px;
  width: 245px;
  z-index: 20;
  top: 10px;
  input {
    height: 41px;
    text-transform: uppercase;
    font-size: 15px;
    padding-bottom: 8px;
    border: 0;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;

    &::placeholder {
      text-transform: none;
    }
  }
  svg {
    color: #1181ed;
    font-size: 19px;
    cursor: pointer;
  }
`;

export const Container = styled.div`
  margin-top: 0;
  display: flex;
  flex-direction: column;
  height: 100vh;

  .ant-spin {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const LogoSpinner = styled.div`
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  opacity: 0.7;
  background-image: url('/assets/images/fixtagone.png');
  background-size: contain;
  width: 35px;
  height: 35px;
  animation-name: spin;
  animation-duration: 1700ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
`;

export const Header = styled.div`
  align-items: center;
  min-height: 46px;
  z-index: 2;
  background: #efefef;
  -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);
  -moz-box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);
  padding: 0 14px;
  margin: 0;
`;

export const MapView = styled.div`
  flex-grow: 1;
  position: relative;
`;

export const MapMount = styled.div`
  position: relative;
  height: 100%;
  z-index: 1;
`;

export const MapFooter = styled.div`
  position: absolute;
  bottom: 25px;
  right: 62px;
  z-index: 1;
  text-align: right;
  display: flex;
`;

export const ContainFormRight = styled.div`
  position: fixed;
  background: #fff;
  border-radius: 3px;
  padding: 18px;
  top: 105px;
  z-index: 999;
  right: 10px;
  bottom: 24px;
  width: 270px;
  border: 1px solid #ced4da;
  box-shadow: 1px 1px 0 0 hsla(0, 0%, 81%, 0.77);
`;

export const NewZoneButton = styled.button`
  background: #1181ed;
  padding: 10px 14px;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 1px 4px 0px;
  font-weight: 550;
  border-radius: 4px;
  border: 0;
  color: white;
`;

export const DownloadOutboundsButton = styled.button`
  display: inline-flex;
  background: #1181ed;
  padding: 10px 14px;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 1px 4px 0px;
  font-weight: 550;
  border-radius: 4px;
  border: 0;
  color: white;
  margin-right: 20px;
  background: white;
  color: rgb(16, 130, 234);

  i {
    font-size: 20px;
    padding-right: 7px;
  }

  .ant-spin {
    padding-right: 7px;
    height: 20px;

    .ant-spin-dot {
      width: 20px;
      height: 20px;
    }
  }
`;
